import React from "react";

const Text4 = () => {

  React.useEffect(() => {
    // 👇️ scroll to top on page load, behavior can be snappy with 'auto'
    document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });}
    , []);
    return(
      <>
        <p className="content-heading" id="top">
        Steg för lönsamhet  
      </p>

      <div className="content-text mt-4">
        <p>
          Under hela processen arbetar du med utbudsmixen som bas och kan när som helst uppdatera fasta kostnader,
          åtgärder och skattesatser. Varje  inmatningar du gör påverkar din möjliga Månadslön som visas - <i>live </i>
          - var du än befinner dig i <i>din</i>BiZ.                 
        </p>
        <p>
          För att analysera och utvärdera lönsamheten hos din affärsidé inleder du med att registrera dina - rimliga - data 
          för företagets                     
        </p>
        <ul>
          <li>
            Utbudsmix
          </li>
          <li className="mt-1">
            Intäkter
          </li>
          <li className="mt-1">
            Kostnader
          </li>
          <li className="mt-1">
            Etablerings-åtgärder 
          </li>
        </ul>        
        <p>
          Därefter kan du mera i detalj utvärdera den potentiella lönsamheten hos din idé och din planering -
          tre år framåt. Vanligt är två till flera <i>din</i>BiZ-körningar med tid för tankar/efterforskning mellan. 
          Steg för steg innebär det                    
        </p>

        <p className="heading2 ms-4 mt-4">
          1. Ökad Lönsamhet 
        </p>
        <p className="ms-4">
           Ditt planerade utbud består av minst ett - och oftast flera/många erbjudanden.                          
        </p>
        <p className="ms-4">
          <i>Exempel - Resturang:</i>
          <ol>
            <li className="mt-1">Lunch/Dagens </li>
            <li className="mt-1">Lunch/Vego </li>
            <li className="mt-1">Lunch/Special </li>
            <li className="mt-1">A lá Carte/Pannbiff med Lök </li>
            <li className="mt-1">A lá Carte/Grillad Kycklingfilé </li>
            <li className="mt-1">A lá Carte/Spätta m Remouladesås </li>
          </ol>
        </p>
        <p className="ms-4">
          För varje erbjudande laborera du med sannolika priser, rörliga kostnader och volymer för högsta täckningsbidrag
          (i kronor per år). När du i steg 3 nedan sätter ihop ditt lönsammaste utbud, blir täckingsbidraget en vattendelare 
          för vilka erbjudanden som får vara med på marknaden och vilka som bor i byrålådan. 
        </p>

        <p className="heading2 ms-4 mt-4">
          2. Bygg Lönsammare Utbudsmix
        </p>
        <p className="ms-4">
          Välj ut de lönsammaste av dina erbjudanden till ditt nya marknadsutbud - ofta de som ger högst täckningbidrag per 
          enhet/timme/år, eller annan kategori. 
        </p>
        <p className="ms-4">
          Tänk efter hur du definierar lönsamhet för varje erbjudande. Kortsiktigt/långsiktigt? Goodwill? Marknadsandelar? 
          Allt är inte kronor!
        </p>
        <p className="ms-4">
          Så långt du kan: Bygg ditt marknadserbjudande på ditt utvalda utbud, fokusera resurserna där. Du kan ha fler 
          erbjudanden i sortimentet men de få lägre resurser och uppmärksamhet. Resurser kan även fördelas internt inom 
          utbudsmixen.
        </p>
        <p className="ms-4">
          Fundera också gärna över hur de kan samverka i marknadsföringen, som att bundlas ihop till komplexare erbjudande 
          och så vidare. Glöm aldrig <span className="strong">kundens perspektiv</span> när du planerar!
        </p>
        <p className="ms-4">
          Innan du exkluderar ett <i>mindre</i> lönsamt erbjudande bör du ändå besluta ifall det kan tillföra något annat 
          lönsamhetsvärde än täckningsbidrag (kundmagnet, goodwill-putsare…?) och vad det är värt - i närtid och i framtid? 
        </p>
          
        <p className="heading2 ms-4 mt-4">
          3. Fasta Kostnader
        </p>
        <p className="ms-4">
          Det är täckningsbidraget från försäljningen som ska betala företagets fasta kostnader - inklusive din lön. 
        </p>
        <p className="ms-4">
          I <i>din</i>BiZ registrerar du nödvändiga fasta kostnader steg för steg efterhand som de kan identifieras.                             
        </p>
        <p className="ms-4">
          Det är mycket viktigt att du håller ner företagets kostnader - fasta så klart men även rörliga då varje kostnad 
          belastar företagets lönsamhet med minskat möjligt löneuttag, vilket  - direkt - återspeglas i fältet: Månadslön 
          (netto).                          
        </p>

        <p className="heading2 ms-4 mt-4">
          4. Vägen mot Mål
        </p>
        <p className="ms-4">
          En väl definierad vägkarta underlättar att nå ditt mål. Annars blir det svårare.                          
        </p>
        <p className="ms-4">
          Hur ser vägen ut? Vilka möjligheter ser du? Vilka hinder? Vilka steg behöver tas? Vilka milstolpar att passera?                               
        </p>
        <p className="ms-4">
          Vad behöver ske för att gå från start till mål? Eller ens till nästa milstolpe? Hur vill du gå tillväga? 
          Vad kostar det? Orkar du? Hinner du?                           
        </p>
        <p className="ms-4">
          I <i>din</i>BiZ  registrerar du nödvändiga åtgärder - steg för steg - och får en mycket tydlig vägkarta som ett 
          instrument att styra färden - med god kostnadskontroll.                           
        </p>
        <p className="ms-4">
          Du får på kuppen gediget underlag för likviditetsbudget, affärsplan och bankkredit/extern finansiering.                         
        </p>

        <p className="heading2 ms-4 mt-4">
          5. Utvärdera din Affärsidé
        </p>
        <p className="ms-4">
          Besluta ifall möjligt löneuttag <i>motsvarar ditt behov</i>.                           
        </p>   
        <ul className="ms-4">
          <li>
            Om JA har du grönt ljus och flygande start att realisera din idé. Du har också ett fint underlag för att söka 
            extern finansiering, bankkredit, bidrag. 
          </li>
        </ul>  
        <ul className="ms-4">
          <li>
            Om NEJ  - se över 
            <ul>
              <li className="mt-1"> Varje erbjudandes potential - missat något? </li>
              <li className="mt-1"> Marknadssegment - finns lönsammare målkundkund? </li>
              <li className="mt-1"> Utbudsmixen - ta bort, lägga till, räkna om? </li>
              <li className="mt-1"> 
                Samlade kostnader - var kan du trimma midjan? 
                <ul>
                  <li className="mt-1"> Fasta </li>
                  <li className="mt-1"> Rörliga </li>
                  <li className="mt-1"> Åtgärdskostnader </li>
                </ul>
              </li>
              <li className="mt-1"> Goda Kostnader - kan ökade investeringar ge högre lönsamhet? </li>
              <li className="mt-1"> Volymer - sälja mer genom partners, agenter, återförsäljare ex v </li>
            </ul>
          </li>
        </ul>                                
        <p className="ms-4">
          Hur kan  priser höjas? Kostnader sänkas? Volymer ökas? Finns kostnader du kan skjuta upp? Krympa? 
          Smeta ut över tid? Eliminera? Tänk gärna ”Out of the Box”.                            
        </p>
                  
      </div>
    </>
  );
}
export default Text4;

